import { createSlice } from "@reduxjs/toolkit";
import { CommonProps } from "./Common";

const initialState: CommonProps.State = { isArticleFullScreen: false };
export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setIsArticleFullScreen: (
      state,
      action: CommonProps.setIsArticleFullScreen
    ) => {
      state.isArticleFullScreen = action.payload;
    },
  },
});

export const { actions: commonActions, reducer: commonReducer } = commonSlice;
